import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarToggler,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { environment } from '../common/util';
import { logout } from '../actions/auth';
import { toggleSidebar } from '../actions/admin/layout';

class Header extends Component {
  constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
          dropdownOpen: false,
        };
  }

  toggle() {
        this.setState({
          dropdownOpen: !this.state.dropdownOpen,
        });
  }

  render() {
    const { auth, logout, toggleSidebar } = this.props;

    return (
      <header className="app-header">
        <nav
          className="navbar top-navbar navbar-dark"
          role="navigation"
        >
          <div className="navbar-header">
            <div className="navbar-brand">
              <Link to="/admin">
                Monstyr
                <span style={{
                  background:   (environment() === 'LOCAL' ? '#2980b9' : (environment() === 'PROD') ? '#8e44ad' : '#e67e22'),
                  position:     'relative',
                  margin:       '10px 5px',
                  top:          '-9px',
                  padding:      '5px 10px',
                  fontSize:     10,
                  borderRadius: 10,
                }}
                >
                  {environment()}
                </span>
              </Link>
            </div>
            <div className="toggler">
              <NavbarToggler onClick={toggleSidebar} />
            </div>
          </div>
          <div className="navbar-wrapper">
            {auth.isAuthenticated ? (
              <>
                <ButtonDropdown
                  isOpen={this.state.dropdownOpen}
                  toggle={this.toggle}
                >
                  <DropdownToggle className="" caret>
                    <i
                      className="fa fa-cog"
                      aria-hidden="true"
                    />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <span
                        onClick={logout}
                        style={{
                          cursor:  'pointer',
                          display: 'block',
                        }}
                        aria-hidden="true"
                      >
                        <i
                          className="fa fa-sign-out"
                          aria-hidden="true"
                        />
                        Logout
                      </span>
                    </DropdownItem>
                  </DropdownMenu>
                </ButtonDropdown>
              </>
            ) : (
              <></>
            )}
          </div>
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  auth:          PropTypes.object.isRequired,
  logout:        PropTypes.func.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout, toggleSidebar })(Header);
